// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"4988d5cf","403":"0ed329c8","424":"df92eccc","608":"ff1a6354","644":"3d2bec5b","748":"fa16a074"}[chunkId] + ".chunk.js";
};